module.exports = __webpack_public_path__ + "img/porto-4.f139393a.png";